import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "parking"
const ParkingIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.75 7.053V6.563H12.812L12.938 6.57C13.04 6.576 13.185 6.59 13.354 6.613 13.69 6.662 14.151 6.761 14.626 6.969S15.623 7.509 16.026 8.039C16.44 8.582 16.689 9.277 16.689 10.125S16.44 11.668 16.026 12.211C15.623 12.74 15.1 13.073 14.626 13.28S13.689 13.588 13.354 13.637C13.184 13.662 13.041 13.674 12.938 13.681L12.81 13.687H12.75L12.75 12.75V13.688H10.689V17.25H8.812V6.563H12.752zM10.688 11.813H12.756L12.82 11.809C12.88 11.805 12.972 11.797 13.083 11.78 13.311 11.748 13.6 11.683 13.874 11.563S14.377 11.283 14.536 11.074C14.685 10.88 14.813 10.59 14.813 10.125S14.685 9.371 14.536 9.175C14.377 8.969 14.149 8.808 13.874 8.688S13.311 8.502 13.084 8.47C12.971 8.453 12.88 8.445 12.82 8.441L12.757 8.437H10.687z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M20.25 2.25C21.078 2.25 21.75 2.922 21.75 3.75Q21.75 3.826 21.742 3.9H21.75V20.25C21.75 21.078 21.078 21.75 20.25 21.75H3.75C2.922 21.75 2.25 21.078 2.25 20.25V3.75C2.25 2.922 2.922 2.25 3.75 2.25zM3.75 3.75V20.25H20.25V3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ParkingIcon
